export const LoadingScreen = () => (
  <div className="flex h-screen w-screen items-center justify-center">
    <div className="bg-primary-700 animation-delay-100 m-2 h-2 w-2 animate-ping rounded-full " />
    <div className="bg-primary-700 animation-delay-200 m-2 h-2 w-2 animate-ping rounded-full " />
    <div className="bg-primary-700 animation-delay-300 m-2 h-2 w-2 animate-ping rounded-full " />
    <div className="bg-primary-700 animation-delay-400 m-2 h-2 w-2 animate-ping rounded-full" />
  </div>
);
